// Shared
export const HD_URL = 'https://www.homedepot.com';
export const APPENDED_BRAND_NAME = ' - The Home Depot';
export const OPEN_GRAPH_FACEBOOK_ADMIN = '100005416960152';
export const IMAGE_REGEX = /[/.](gif|jpg|jpeg|tiff|png)$/g;

// Article Metadata
export const ARTICLE_BUYING_GUIDE_REGEX = /ab/i;
export const ARTICLE_INSPIRATION_GUIDE_REGEX = /ai/i;
export const ARTICLE_PROJECT_GUIDE_REGEX = /ah/i;
export const ARTICLE_INFLUENCER_GUIDE_REGEX = /ap/i;

// Product Metadata
export const IMAGE_SIZE_REGEX = /_\d+./gm;
export const IMAGE_SIZE_URL_PARAM_REGEX = /_<SIZE>./g;

// Browse and search Metadata
export const ALLOWED_PLPS = [
  'Building-Materials-Concrete-Cement-Masonry-Decorative-Concrete-Pavers-Step-Stones',
  'Outdoors-Garden-Center-Hardscapes',
  'Outdoors-Garden-Center-Hardscapes-Outdoor-Living-Kits',
  'Outdoors-Garden-Center-Hardscapes-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Brick-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Concrete-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Plastic-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Porcelain-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Rubber-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Stepping-Stones',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Stone-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Pavers-Travertine-Pavers',
  'Outdoors-Garden-Center-Hardscapes-Wall-Blocks',
  'Outdoors-Garden-Center-Hardscapes-Wall-Blocks-Garden-Wall-Blocks',
  'Outdoors-Garden-Center-Hardscapes-Wall-Blocks-Pool-Coping',
  'Outdoors-Garden-Center-Hardscapes-Wall-Blocks-Retaining-Wall-Blocks',
  'Outdoors-Garden-Center-Hardscapes-Wall-Blocks-Wall-Caps',
  'Outdoors-Garden-Center-Landscaping-Supplies',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Accessories',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Edging-Brick-Edging',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Edging-Concrete-Edging',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Edging-Edging-Stones',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Rocks',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Rocks-Bagged-Landscape-Rocks',
  'Outdoors-Garden-Center-Landscaping-Supplies-Landscape-Rocks-Bulk-Landscape-Rocks',
  'Outdoors-Garden-Center-Landscaping-Supplies-Sand',
  'Outdoors-Outdoor-Heating-Fire-Glass',
  'Outdoors-Outdoor-Heating-Fire-Pits-Fire-Pit-Kits',
  'Outdoors-Pet-Supplies-Wildlife-Fish-Supplies-Fish-Food-Health-Care-Aquarium-Water-Conditioner',
  'Outdoors-Outdoor-Power-Equipment-Lawn-Mowers',
  'Outdoors-Outdoor-Power-Equipment-Lawn-Mowers-Push-Lawn-Mowers',
  'Outdoors-Outdoor-Power-Equipment-Lawn-Mowers-Reel-Lawn-Mowers',
  'Outdoors-Outdoor-Power-Equipment-Lawn-Mowers-Robotic-Lawn-Mowers',
  'Outdoors-Outdoor-Power-Equipment-Lawn-Mowers-Self-Propelled-Lawn-Mowers',
  'Outdoors-Outdoor-Power-Equipment-Outdoor-Power-Equipment-Parts-Fuel-Cans-Gas-Can-Accessories'];

export const PAGE_TYPE = {
  DETAILS: 'details',
  REVIEWS: 'reviews'
};